document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Find the Swiper instance on the main slider
    var sliderEl = document.querySelector('.js-media-list');
    if (sliderEl && sliderEl.swiper) {
      sliderEl.swiper.params.autoplay = {
        delay: 3000,
        disableOnInteraction: false
      };
      sliderEl.swiper.autoplay.start();
    }
  }, 1000);
});
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var el = document.querySelector('.js-media-list');
    if (!el || !el.swiper) return;
    
    var swiper = el.swiper;
    var total = swiper.slides.length;
    
    var dotsDiv = document.createElement('div');
    dotsDiv.style.cssText = 'position:absolute;bottom:15px;left:50%;transform:translateX(-50%);z-index:10;display:flex;gap:6px;';
    
    for (var i = 0; i < total; i++) {
      var dot = document.createElement('span');
      dot.style.cssText = 'display:inline-block;width:8px;height:8px;border-radius:50%;background:#ccc;cursor:pointer;transition:background 0.3s;';
      if (i === 0) dot.style.background = '#333';
      (function(index) {
        dot.onclick = function() { swiper.slideTo(index); };
      })(i);
      dotsDiv.appendChild(dot);
    }
    
    el.style.position = 'relative';
    el.appendChild(dotsDiv);
    
    swiper.on('slideChange', function() {
      var dots = dotsDiv.querySelectorAll('span');
      dots.forEach(function(d, i) {
        d.style.background = i === swiper.realIndex ? '#333' : '#ccc';
      });
    });
  }, 2000);
});